import React, { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component
import { useNavigate } from "react-router-dom/dist";

import "./VesselManagement.scss";
import "./NewVessel";
import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/styles/ag-theme-alpine.css'; // Optional theme CSS
import VesselServices from "../../services/api/VesselServices";
import NewVessel from './NewVessel';
import { useMainContext } from "../../dataproviders/MainDataProvider";
import { useVesselContext } from "../../dataproviders/VesselDataProvider";
import { useAuthContext } from '../../dataproviders/AuthDataProvider';

function VesselManagement() {
    const mainContext = useMainContext();
    const authContext = useAuthContext();
    const vesselContext = useVesselContext();
    const navigate = useNavigate();
    const gridRef = useRef(); // Optional - for accessing Grid's API
    const [rowData, setRowData] = useState(); // Set rowData to Array of Objects, one Object per Row
    const [containerHeight, setContainerHeight] = useState(0); // Initialize containerHeight
    const [isMobileScreen, setIsMobileScreen] = useState(false); // Initialize the mobile screen state
    //const [errors, setErrors] = useState([]);
    const [vessel, setVessel] = useState("default");
    const [invalidVesselError, setInvalidVesselError] = useState(false);
    
    class VesselManagementCellRenderer {
        init(params) {
            this.params = params;
            this.eGui = this.createContextMenu();
        }

        createContextMenu() {
            const contextMenu = document.createElement('div');
            contextMenu.classList.add('context-menu');
            contextMenu.classList.add('dropdown');
            contextMenu.classList.add('dropdown-vesselmgmt');

            const toggleBtn = document.createElement('button');
            toggleBtn.classList.add('dropdown-toggle');
            toggleBtn.setAttribute('type', 'button');
            toggleBtn.innerHTML = '<i class="fa-solid fa-ellipsis-vertical"></i>';
            toggleBtn.addEventListener('click', this.toggleHandler);

            const dropdownMenu = document.createElement('div');
            dropdownMenu.classList.add('dropdown-menu');

            // edit vessel
            const editVesselBtn = document.createElement('button');
            editVesselBtn.classList.add('dropdown-item');
            editVesselBtn.innerHTML = '<i class="fa-light fa-pencil"></i> Edit Vessel';
            this.editVesselHandler = this.editVesselHandler.bind(this);
            editVesselBtn.addEventListener('click', this.editVesselHandler);

            // activate/deactivate vessel
            const toggleStatusBtn = document.createElement('button');
            toggleStatusBtn.classList.add('dropdown-item');

            if (this.params.data.status === 1) {
                toggleStatusBtn.innerHTML = '<i class="fa-regular fa-ship"></i> Disable Vessel';
                this.deactivateStatusHandler = this.deactivateStatusHandler.bind(this);
                toggleStatusBtn.addEventListener('click', this.deactivateStatusHandler);
            }
            else if (this.params.data.status === 2) {
                toggleStatusBtn.innerHTML = '<i class="fa-solid fa-ship"></i> Enable Vessel';
                this.activateStatusHandler = this.activateStatusHandler.bind(this);
                toggleStatusBtn.addEventListener('click', this.activateStatusHandler);
            }

            // remove vessel
            const removeVesselBtn = document.createElement('button');
            removeVesselBtn.classList.add('dropdown-item');
            removeVesselBtn.classList.add('dropdown-item-top-border');
            removeVesselBtn.innerHTML = '<i class="fa-regular fa-trash-can"></i> Delete';
            this.removeVesselHandler = this.removeVesselHandler.bind(this);
            removeVesselBtn.addEventListener('click', this.removeVesselHandler);

            // add buttons to dropdown menu
            dropdownMenu.appendChild(editVesselBtn);
            dropdownMenu.appendChild(toggleStatusBtn);
            dropdownMenu.appendChild(removeVesselBtn);

            contextMenu.appendChild(toggleBtn);
            contextMenu.appendChild(dropdownMenu);
            return contextMenu;
        }

        getGui() {
            return this.eGui;
        }

        toggleHandler(e) {
            let el = e.target.closest('.dropdown-vesselmgmt').querySelector('.dropdown-menu');

            // Check if the element has the .show class
            if (el.classList.contains('show')) {
                //hide all dropdown-menu with .show
                const dropdownMenus = document.querySelectorAll('.dropdown-menu.show');
                dropdownMenus.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('show');
                });

                //hide all dropdown-menu with .show
                const dropdownMenusMgmt = document.querySelectorAll('.dropdown-vesselmgmt.col-rps-light');
                dropdownMenusMgmt.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('col-rps-light');
                });
            }
            else {
                //hide all dropdown-menu with .show
                const dropdownMenus = document.querySelectorAll('.dropdown-menu.show');
                dropdownMenus.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('show');
                });

                //hide all dropdown-menu with .show
                const dropdownMenusMgmt = document.querySelectorAll('.dropdown-vesselmgmt.col-rps-light');
                dropdownMenusMgmt.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('col-rps-light');
                });

                const dropdownMenu = el;
                dropdownMenu.classList.toggle('show');

                e.target.closest('.dropdown-vesselmgmt').classList.toggle('col-rps-light');
            }

            const container = document.querySelector('.vessel-management-container');
            const targetElement = container.querySelector('.dropdown-menu.show');

            if (targetElement) {
                const containerScrollHeight = container.scrollHeight;
                const containerRect = container.getBoundingClientRect();
                const targetElementRect = targetElement.getBoundingClientRect();

                const targetTop = targetElementRect.top - containerRect.top + container.scrollTop;
                const targetHeight = targetElementRect.height;

                if (targetTop + targetHeight > containerScrollHeight) {
                    targetElement.style.top = (-targetHeight) + 'px';
                }
            }

        }

        editVesselHandler(e) {
            const container = document.querySelector('.dialog-overlay-reset-vessel');

            if (container) {
                //hide all dropdown-menu with .show
                const dropdownMenus = document.querySelectorAll('.dropdown-menu.show');
                dropdownMenus.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('show');
                });

                //hide all dropdown-menu with .show
                const dropdownMenusMgmt = document.querySelectorAll('.dropdown-vesselmgmt.col-rps-light');
                dropdownMenusMgmt.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('col-rps-light');
                });

                container.classList.remove('hide');

                const btn = document.querySelector('.btn-vessel-reset-vessel');
                btn.setAttribute('vesselid', this.params.data.vesselid);
                btn.setAttribute('vesselname', this.params.data.vesselname);

                const txt = document.querySelector('.txt-vessel-reset-vessel');
                txt.value = this.params.data.vesselname;
            }
        }

        activateStatusHandler(e) {
            const container = document.querySelector('.dialog-overlay-activate');

            if (container) {
                //hide all dropdown-menu with .show
                const dropdownMenus = document.querySelectorAll('.dropdown-menu.show');
                dropdownMenus.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('show');
                });

                //hide all dropdown-menu with .show
                const dropdownMenusMgmt = document.querySelectorAll('.dropdown-vesselmgmt.col-rps-light');
                dropdownMenusMgmt.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('col-rps-light');
                });

                container.classList.remove('hide');

                const preferedNames = document.querySelectorAll('.vessel-name-section');
                preferedNames.forEach((preferedName) => {
                    preferedName.innerHTML = this.params.data.vesselname;
                });

                const btn = document.querySelector('.btn-vessel-activate');
                btn.setAttribute('vesselid', this.params.data.vesselid);
                btn.setAttribute('vesselname', this.params.data.vesselname);
            }
        }

        deactivateStatusHandler(e) {
            const container = document.querySelector('.dialog-overlay-deactivate');

            if (container) {
                //hide all dropdown-menu with .show
                const dropdownMenus = document.querySelectorAll('.dropdown-menu.show');
                dropdownMenus.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('show');
                });

                //hide all dropdown-menu with .show
                const dropdownMenusMgmt = document.querySelectorAll('.dropdown-vesselmgmt.col-rps-light');
                dropdownMenusMgmt.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('col-rps-light');
                });
                container.classList.remove('hide');

                const preferedNames = document.querySelectorAll('.vessel-name-section');
                preferedNames.forEach((preferedName) => {
                    preferedName.innerHTML = this.params.data.vesselname;
                });

                const btn = document.querySelector('.btn-vessel-deactivate');
                btn.setAttribute('vesselid', this.params.data.vesselid);
                btn.setAttribute('vesselname', this.params.data.vesselname);
            }
        }

        removeVesselHandler(e) {
            const container = document.querySelector('.dialog-overlay-remove');

            if (container) {
                //hide all dropdown-menu with .show
                const dropdownMenus = document.querySelectorAll('.dropdown-menu.show');
                dropdownMenus.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('show');
                });

                //hide all dropdown-menu with .show
                const dropdownMenusMgmt = document.querySelectorAll('.dropdown-vesselmgmt.col-rps-light');
                dropdownMenusMgmt.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('col-rps-light');
                });
                container.classList.remove('hide');

                const preferedNames = document.querySelectorAll('.vessel-name-section');
                preferedNames.forEach((preferedName) => {
                    preferedName.innerHTML = this.params.data.vesselname;
                });

                const btn = document.querySelector('.btn-vessel-remove');
                btn.setAttribute('vesselid', this.params.data.vesselid);
                btn.setAttribute('vesselname', this.params.data.vesselname);
            }
        }

        destroy() {
            this.eGui.removeEventListener('click', this.toggleHandler);
            this.eGui.removeEventListener('click', this.editVesselHandler);
            this.eGui.removeEventListener('click', this.activateStatusHandler);
            this.eGui.removeEventListener('click', this.deactivateStatusHandler);
            this.eGui.removeEventListener('click', this.removeVesselHandler);
        }
    }

    // Each Column Definition results in one Column.
    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: '',
            field: 'vesselid',
            cellClass: ['actions-button-cell'],
            cellRenderer: VesselManagementCellRenderer,
            minWidth: 24,
            maxWidth: 24,
            sortable: false,
            filter: false,
            resizable: false
        },
        {
            headerName: 'Vessel ID',
            cellClass: ['d-flex', 'text-wrap', 'ag-cell-custom-text', 'allow-text-select'],
            field: 'vesselid',
            maxWidth: 320,
            minWidth: 320,
            sortable: false,
            filter: false,
            resizable: false
        },
        {
            headerName: 'Vessel Name',
            cellClass: ['d-flex', 'text-wrap', 'ag-cell-custom-text'],
            field: 'vesselname'
        },
        {
            headerName: 'Status',
            field: 'status',
            maxWidth: 120,
            minWidth: 120,
            filter: false,
            cellRenderer: params => {
                var cell = '';
                if (params.data.status === 1) {
                    cell += 'Enabled';
                }
                else {
                    cell += 'Disabled';
                }

                return cell;
            },
            cellClass: params => {
                if (params.data.status === 1) {
                    return ['d-flex', 'text-wrap', 'col-green', 'ag-cell-custom-text'];
                }
                else {
                    return ['d-flex', 'text-wrap', 'ag-cell-custom-text'];
                }
            },
            resizable: false
        }
    ]);

    const sizeToFit = useCallback(() => {
        // Check if gridRef.current is not null before accessing the 'api' property
        if (gridRef.current) {
            gridRef.current.api.sizeColumnsToFit({
                defaultMinWidth: 100
            });
        }
    }, []);

    const handleResize = useCallback(() => {
        // Calculate the new container height on window resize
        const newContainerHeight = window.innerHeight - 350;
        setContainerHeight(newContainerHeight);

        // Detect mobile screen size (width <= 768px)
        const isMobile = window.innerWidth <= 768;
        setIsMobileScreen(isMobile);

        sizeToFit();
    }, []);

    // DefaultColDef sets props common to all Columns
    const defaultColDef = useMemo(() => ({
        sortable: true,
        filter: true,
        resizable: true,
        suppressMovable: true,
        // override all the defaults with font awesome
        icons: {
            // use font awesome for menu icons
            menu:'<i class="fa-solid fa-filter"></i>'
        }
    }));

    // Example of consuming Grid Event
    const cellClickedListener = useCallback(e => {
        const headerName = e.colDef.headerName;
        const colIndex = e.api
            .getColumns()
            ?.findIndex((col) => col.getColDef().headerName === headerName);

        //if not first cell, go inside to hide all
        if (colIndex > 0) {
            //hide all dropdown-menu with .show
            const dropdownMenus = document.querySelectorAll('.dropdown-menu.show');
            dropdownMenus.forEach((dropdownMenu) => {
                dropdownMenu.classList.remove('show');
            });

            //hide all dropdown-menu with .show
            const dropdownMenusMgmt = document.querySelectorAll('.dropdown-vesselmgmt.col-rps-light');
            dropdownMenusMgmt.forEach((dropdownMenu) => {
                dropdownMenu.classList.remove('col-rps-light');
            });
        }

    }, []);

    useEffect(() => {
        // Add event listener for screen size change
        window.addEventListener('resize', handleResize);
        return () => {
            // Cleanup: remove event listener on component unmount
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (rowData !== undefined) {
            handleResize();
        }
    }, [rowData]); // Add rowData as a dependency so that this useEffect only runs when rowData changes

    // Example load data from server
    useEffect(() => {
        const _auth = JSON.parse(sessionStorage.getItem("auth"));
      
        if (!!_auth) {
            const role = _auth.role;

            //0:Admin, 1:Operator, 2:Project Manager, 3:Client
            if (role === 0 || role === 2) {
                getAllVessels();
            }
            else {
                navigate("/projects");
            }
        }
        else {
            getAllVessels();
        }

        vesselContext.SetRefreshFlag(false);
    }, [vesselContext.RefreshFlag]);

    const getAllVessels = async () => {
        const result = await VesselServices.GetAllVessels();

        if (!!result) {
            setRowData(result.data);
        }
    };

    const handleEditVessel = async (e) => {
        let vessel = document.getElementById("txtAdminVesselName").value;
        setVessel(vessel);

        if (!(vessel === '' || invalidVesselError === true)) {
            const cancelButton = e.currentTarget;

            try {
                // Disable the button and add the loading class
                cancelButton.disabled = true;
                cancelButton.innerHTML = '';
                cancelButton.classList.add('loading');

                let vesselid = cancelButton.getAttribute('vesselid');

                const flag = await VesselServices.EditVessel(vesselid, vessel);

                if (!!flag) {
                    const result = await VesselServices.GetAllVessels();

                    if (!!result) {
                        setRowData(result.data);
                    }

                    if (flag.data !== null &&
                        flag.data.errormessage === null) {
                        handleError('Success', 'Vessel has been successfully saved.');
                    }
                    else {
                        handleError('Error', `Vessel has failed to save due to ${flag.data.errormessage.toLowerCase()} Please try again.`);
                    }
                }
                else {
                    // Display error message for network errors
                    handleError('Error', 'Vessel has failed to save due to system error. Please try again.');
                }

                hideEditVessel(cancelButton);
            }
            catch (error) {
                // Display error message for network errors
                handleError('Error', 'An error occurred. Please try again later.');
            }
            finally {
                // Enable the button and remove the loading class
                cancelButton.disabled = false;
                cancelButton.innerHTML = 'Yes';
                cancelButton.classList.remove('loading');
            }
        }
    };

    const handleDeactivate = async (e) => {
        const cancelButton = e.currentTarget;

        try {
            // Disable the button and add the loading class
            cancelButton.disabled = true;
            cancelButton.innerHTML = '';
            cancelButton.classList.add('loading');

            let vesselid = cancelButton.getAttribute('vesselid');

            const flag = await VesselServices.SetVesselStatus(vesselid, 2);

            if (!!flag) {
                const result = await VesselServices.GetAllVessels();

                if (!!result) {
                    setRowData(result.data);
                }

                let vesselname = cancelButton.getAttribute('vesselname');
                handleError('Success', vesselname + " vessel has been disabled.");
            }
            else {
                // Display error message for network errors
                handleError('Error', 'Vessel has failed to disable due to system error. Please try again.');
            }

            hideDeactivate(cancelButton);
        }
        catch (error) {
            // Display error message for network errors
            handleError('Error', 'An error occurred. Please try again later.');
        }
        finally {
            // Enable the button and remove the loading class
            cancelButton.disabled = false;
            cancelButton.innerHTML = 'Yes';
            cancelButton.classList.remove('loading');
        }
    };

    const handleActivate = async (e) => {
        const cancelButton = e.currentTarget;

        try {
            // Disable the button and add the loading class
            cancelButton.disabled = true;
            cancelButton.innerHTML = '';
            cancelButton.classList.add('loading');

            let vesselid = cancelButton.getAttribute('vesselid');

            const flag = await VesselServices.SetVesselStatus(vesselid, 1);

            if (!!flag) {
                const result = await VesselServices.GetAllVessels();

                if (!!result) {
                    setRowData(result.data);
                }

                let vesselname = cancelButton.getAttribute('vesselname');
                handleError('Success', vesselname + " vessel has been enabled.");
            }
            else {
                // Display error message for network errors
                handleError('Error', 'Vessel has failed to enable due to system error. Please try again.');
            }

            hideActivate(cancelButton);
        }
        catch (error) {
            // Display error message for network errors
            handleError('Error', 'An error occurred. Please try again later.');
        }
        finally {
            // Enable the button and remove the loading class
            cancelButton.disabled = false;
            cancelButton.innerHTML = 'Yes';
            cancelButton.classList.remove('loading');
        }
    };

    const handleRemove = async (e) => {
        const cancelButton = e.currentTarget;

        try {
            // Disable the button and add the loading class
            cancelButton.disabled = true;
            cancelButton.innerHTML = '';
            cancelButton.classList.add('loading');

            let vesselid = cancelButton.getAttribute('vesselid');

            const flag = await VesselServices.DeleteVessel(vesselid);

            if (!!flag) {
                if (typeof flag.data.errormessage === 'undefined' || flag.data.errormessage === null || flag.data.errormessage === "") {
                    const result = await VesselServices.GetAllVessels();

                    if (!!result) {
                        setRowData(result.data);
                    }

                    let vesselname = cancelButton.getAttribute('vesselname');
                    handleError('Success', vesselname + " vessel has been deleted.");
                }
                else {
                    // Display error message for network errors
                    handleError('Error', `Vessel has failed to delete due to ${flag.data.errormessage.toLowerCase()} Please try again.`);
                }
            }
            else {
                // Display error message for network errors
                handleError('Error', 'Vessel has failed to delete due to system error. Please try again.');
            }

            hideRemove(cancelButton);
        }
        catch (error) {
            // Display error message for network errors
            handleError('Error', 'An error occurred. Please try again later.');
        }
        finally {
            // Enable the button and remove the loading class
            cancelButton.disabled = false;
            cancelButton.innerHTML = 'Yes';
            cancelButton.classList.remove('loading');
        }
    };

    const handleCancelEditVessel = (e) => {
        const cancelButton = e.currentTarget;
        hideEditVessel(cancelButton);
    };

    const handleCancelActivate = (e) => {
        const cancelButton = e.currentTarget;
        hideActivate(cancelButton);
    };

    const handleCancelDeactivate = (e) => {
        const cancelButton = e.currentTarget;
        hideDeactivate(cancelButton);
    };

    const handleCancelRemove = (e) => {
        const cancelButton = e.currentTarget;
        hideRemove(cancelButton);
    };

    const handleError = (errorType, errorMessage) => {
        authContext.HandleError(errorType,errorMessage);
    }

    const hideEditVessel = (btn) => {
        document.getElementById("txtAdminVesselName").value = '';
        setVessel('default');
        setInvalidVesselError(false);

        const dialogOverlay = btn.closest('.dialog-overlay-reset-vessel');

        if (dialogOverlay) {
            dialogOverlay.classList.add('hide');
        }
    };

    const hideActivate = (btn) => {
        const dialogOverlay = btn.closest('.dialog-overlay-activate');

        if (dialogOverlay) {
            dialogOverlay.classList.add('hide');
        }
    };

    const hideDeactivate = (btn) => {
        const dialogOverlay = btn.closest('.dialog-overlay-deactivate');

        if (dialogOverlay) {
            dialogOverlay.classList.add('hide');
        }
    };

    const hideRemove = (btn) => {
        const dialogOverlay = btn.closest('.dialog-overlay-remove');

        if (dialogOverlay) {
            dialogOverlay.classList.add('hide');
        }
    };

    const hasVesselError = () => {
        if (vessel !== 'default' &&
            (vessel === '' || invalidVesselError === true)) {
            return "error";
        } else {
            return "";
        }
    };

    const renderVesselErrorMessage = () => {
        if (vessel === '') {
            return (
                <>
                    <label className="offset-w-25 error">
                        <i className="fa-solid fa-circle-info"></i> Vessel name is required.
                    </label>
                </>
            );
        }
        else if (invalidVesselError === true) {
            return (
                <>
                    <label className="offset-w-25 error">
                        <i className="fa-solid fa-circle-info"></i> Vessel name allows only lowercase, uppercase, numbering, space, and symbol characters.
                    </label>
                </>
            );
        }
    };

    const validateVessel = (e) => {
        setVessel(e);

        if (vessel !== '') {
            const vesselReset = /^[a-zA-Z0-9 -~!@#$%^&*(),.<>{}|;':"]*$/;

            if (!vesselReset.test(e)) {
                setInvalidVesselError(true);
            } else {
                setInvalidVesselError(false);
            }
        }
    };

    return (
        <>
       
            <div className="vessel-management-container" style={{ minHeight: '295px', height: `${!isMobileScreen ? `${containerHeight}px` : '100vh'}` }}>
                {/* On div wrapping Grid a) specify theme CSS Class Class and b) sets Grid size */}
                <div className="ag-theme-alpine vessel-management-with-context-menu" style={{ width: '100%', height: '100%' }}>

                    <AgGridReact
                        ref={gridRef} // Ref for accessing Grid's API

                        rowData={rowData} // Row Data for Rows
                        headerHeight={30}
                        rowHeight={30}
                        columnDefs={columnDefs} // Column Defs for Columns
                        defaultColDef={defaultColDef} // Default Column Properties

                        animateRows={true} // Optional - set to 'true' to have rows animate when sorted
                        rowSelection='single' // Options - allows click selection of rows
                        suppressMenuHide={true}
                        // Your grid options here....
                        suppressCellSelection={true}
                        onCellClicked={cellClickedListener} // Optional - registering for Grid Event
                    />
                </div>
                <div className="dialog-overlay dialog-overlay-reset-vessel hide">
                    <div className="dialog-container dialog-container-long">
                        <button className="dialog-close-button" onClick={handleCancelEditVessel}>
                            <i className="fa-solid fa-xmark"></i>
                        </button>
                        <p className="dialog-title col-rps-light mt-0 mb-0">Edit Vessel</p>
                        <div className="dialog-content">
                            <div className="mb-2">
                                <div className="d-flex align-items-center input-label-group">
                                    <label htmlFor="txtAdminVesselName" className="w-25 required">Vessel Name</label>
                                    <input type="text" id="txtAdminVesselName" className={`${hasVesselError()} w-75 txt-vessel-reset-vessel`} onChange={(e) => { validateVessel(e.target.value); }} />
                                </div>
                                {renderVesselErrorMessage()}
                            </div>
                        </div>
                        <div className="dialog-buttons float-right">
                            <button className="btn btn-dialog btn-primary btn-me btn-vessel-reset-vessel" onClick={handleEditVessel}>Yes</button>
                            <button className="btn btn-dialog btn-secondary" onClick={handleCancelEditVessel}>No</button>
                        </div>
                    </div>
                </div>
                <div className="dialog-overlay dialog-overlay-activate hide">
                    <div className="dialog-container">
                        <button className="dialog-close-button" onClick={handleCancelActivate}>
                            <i className="fa-solid fa-xmark"></i>
                        </button>
                        <p className="dialog-title col-rps-light mt-0 mb-0">Enable Vessel</p>
                        <p className="dialog-content">Are you sure wish to enable <span className="vessel-name-section"></span> vessel?</p>
                        <div className="dialog-buttons float-right">
                            <button className="btn btn-dialog btn-primary btn-me btn-vessel-activate" onClick={handleActivate}>Yes</button>
                            <button className="btn btn-dialog btn-secondary" onClick={handleCancelActivate}>No</button>
                        </div>
                    </div>
                </div>
                <div className="dialog-overlay dialog-overlay-deactivate hide">
                    <div className="dialog-container">
                        <button className="dialog-close-button font-big" onClick={handleCancelDeactivate}>
                            <i className="fa-solid fa-xmark"></i>
                        </button>
                        <p className="dialog-title col-rps-light mt-0 mb-0">Disable Vessel</p>
                        <p className="dialog-content">Are you sure wish to disable <span className="vessel-name-section"></span> vessel?</p>
                        <div className="dialog-buttons float-right">
                            <button className="btn btn-dialog btn-primary btn-me btn-vessel-deactivate" onClick={handleDeactivate}>Yes</button>
                            <button className="btn btn-dialog btn-secondary" onClick={handleCancelDeactivate}>No</button>
                        </div>
                    </div>
                </div>
                <div className="dialog-overlay dialog-overlay-remove hide">
                    <div className="dialog-container">
                        <button className="dialog-close-button font-big" onClick={handleCancelRemove}>
                            <i className="fa-solid fa-xmark"></i>
                        </button>
                        <p className="dialog-title col-rps-light mt-0 mb-0">Delete Vessel</p>
                        <p className="dialog-content">Are you sure wish to delete <span className="vessel-name-section"></span> vessel?</p>
                        <div className="dialog-buttons float-right">
                            <button className="btn btn-dialog btn-primary btn-me btn-vessel-remove" onClick={handleRemove}>Yes</button>
                            <button className="btn btn-dialog btn-secondary" onClick={handleCancelRemove}>No</button>
                        </div>
                    </div>
                </div>
                <NewVessel showDialog={mainContext.ShowAddVessel}/>
            </div>
        </>
    );
}

export default VesselManagement;
